<script lang="ts">
  export let message = '';
</script>

{#if message}
  <div class="section">
    <div class="section-title" style="color: var(--warn);">Map key error</div>
    <p class="help-text">{message}</p>
  </div>
{/if}
